import React from "react";

function Support() {
  return (
    <div>
      <h1 className="center">support page</h1>
    </div>
  );
}

export default Support;
